"use client";

import dynamic from "next/dynamic";
import { NuqsAdapter } from "nuqs/adapters/next/app";
import { memo } from "react";

import { NODE_ENV } from "@workspace/shared/constants";

import { CustomerChatProvider } from "~/providers/customer-chat";
import { LemonSqueezyScript } from "~/providers/lemon";
import { ReactScan } from "~/providers/scan";
import { TRPCReactProvider } from "~/trpc/react";

import { env } from "../../env.config";
import { ThemeProvider } from "./theme";

const SessionAnalyticsSync = dynamic(
  () =>
    import("./analytics/session-analytics").then((mod) => ({
      default: mod.SessionAnalyticsSync,
    })),
  { ssr: false },
);

const SessionRecordingProvider = dynamic(
  () =>
    import("./analytics/session-recording").then((mod) => ({
      default: mod.SessionRecordingProvider,
    })),
  { ssr: false },
);

interface ProvidersProps {
  readonly children: React.ReactNode;
}

export const Providers = memo<ProvidersProps>(({ children }) => (
  <TRPCReactProvider>
    <NuqsAdapter>
      {env.NODE_ENV === NODE_ENV.DEVELOPMENT && <ReactScan />}
      <ThemeProvider>{children}</ThemeProvider>
      <SessionAnalyticsSync />
      <SessionRecordingProvider />
      <CustomerChatProvider />
      <LemonSqueezyScript />
    </NuqsAdapter>
  </TRPCReactProvider>
));

Providers.displayName = "Providers";
